import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
// import data from '../../../assets/data/data';

import axios from 'axios';
import * as qs from 'qs';

Vue.use(Vuex);

const siteData = JSON.parse(app.vue_global_data_json);
const items = JSON.parse(app.vue_data_json).items;
const selected = 'selected';

const getNumber = (inx) => {
    if (inx < 9) {
        return `0${inx + 1}`;
    } else {
        return `${inx + 1}`;
    }
}

const defaultModel = () => {
    const model = [];
    if (items) {
        items.forEach((dropdown, inx) => {
            const modelItemObject = {id: '', name: '', result: ''};
            dropdown.items.forEach(dropdownItem => {
                dropdownItem.items.find(subItem => {
                    if (subItem.selected === selected) {
                        modelItemObject.id = getNumber(inx);
                        modelItemObject.name = dropdown.name;
                        modelItemObject.result = subItem.name;

                        model.push(modelItemObject);
                    }
                });
            })
        })
    }
    return model;
}

const defaultSelectedActionName = () => {
    const actionsArr = [];
    const actionsObjArr = {};
    if (items) {
        items.forEach(item => actionsArr.push(item.items[0].items[0].action_id));
        actionsArr.forEach((action) => actionsObjArr[action] = '');
    }
    return actionsObjArr;
}

const defaultFabric = () => {
    let fabric = '';
    if (items) {
        items.forEach(dropdown => {
            dropdown.items.forEach(dropdownItem => {
                dropdownItem.items.find(subItem => {
                    if (subItem.action_id === 'hb:mtl' &&
                    subItem.selected === selected) {
                        fabric = subItem.name;
                    }
                });
            })
        })
    }
    return fabric;
}

const initialState = () => ({
    // siteData: data,
    siteData: siteData,
    items: JSON.parse(app.vue_data_json).items,
    selectedActionName: defaultSelectedActionName(),
    loadProduct: [],
    sentActionName: '',
    selectedResult: {
        name: 'My Vispring Bed Configuration',
        image: app.theme_path + '/assets/img/fake-result.png',
        model: defaultModel(),
    },
    url: '',
    fabric: defaultFabric(),
    retailer: {}
});

export default new Vuex.Store({
    state: initialState(),
    getters: {
        storeItems: (state) => {
            return state.items;
        },
        actionName: (state) => {
            return state.selectedActionName;
        },
        product: (state) => {
            return state.loadProduct;
        },
        hbFabric: (state) => {
            return state.fabric;
        },
        send: (state) => {
            return state.sentActionName;
        },
        model: (state) => {
            return state.selectedResult.model;
        }
    },
    mutations: {
        changeActionName(state, payload) {
            // update items selected
            state.items.forEach(dropdown => {
                dropdown.items.forEach(dropdownItem => {
                    dropdownItem.items.forEach(subItem => {
                        if (subItem.action_id === payload.target) {
                            subItem.selected = '';
                            if (subItem.action === payload.payload) subItem.selected = selected;
                        }
                    });
                })
            })

            // update action name
            state.selectedActionName[payload.target] = payload.payload;
            state.sentActionName = state.selectedActionName[payload.target];
            state.target = payload.target;
        },
        updateLoadProduct(state, payload) {
            state.loadProduct.push(payload);
        },
        checkedFabric(state, payload) {
            state.fabric = payload;
        },
        selectedRetailer(state, payload) {
            state.retailer = payload;
        },
        updateModel(state, payload) {
            state.selectedResult.model = payload;
        },
        updateModelImage(state, payload) {
            state.selectedResult.image = payload;
        },
        resetState(state) {
            const initial = initialState();
            Object.keys(initial).forEach((key) => {
                state[key] = initial[key];
            });
        },
        setUrl(state, payload) {
            state.url = payload;
        }
    },
    actions: {
        sendRequest({commit, state}, requestBody) {
            return axios.post(state.ajaxUrl, qs.stringify(requestBody));
        },
    },
    plugins: [
        createPersistedState({
            storage: window.sessionStorage,
        }),
    ],
});
